
import cookie from '../cookie'
import { isAndroidApp, isIOSApp } from './MobileAppUserAgentChecker'

export const GetTrackingData = () => {
    let trackingData = localStorage.getItem("trackingData")
    if (trackingData) {
        try {
            trackingData = JSON.parse(trackingData)
        }
        catch (e) {
            trackingData = {}
        }
    }
    else trackingData = {}

    return trackingData
}

export const SetTrackingData = (param = {}) => {
    const {
        lang,
        isMobile,
        isLogin
    } = param

    const trackingData = GetTrackingData()

    if (isIOSApp()) trackingData.isIOS = true
    if (isAndroidApp()) trackingData.isAndroid = true
    
    if (isMobile) trackingData.isMobile = true
    if (lang) trackingData.lang = lang
    if (sessionStorage.getItem('country')) trackingData.country = sessionStorage.getItem('country')

    cookie.SetCookie('trackingData', JSON.stringify(trackingData))

    if (isLogin) cookie.SetCookie('isLoginReq', isLogin)
    else cookie.DeleteCookie('isLoginReq')

    localStorage.setItem("trackingData", JSON.stringify(trackingData))
}